/*
 * @Author: 张帮辉
 * @LastEditors: 赵泽文
 * @Date: 2022-05-25 10:19:13
 * @LastEditTime: 2022-05-26 11:43:02
 * @Description: 生产入库单 model
 */
import type {
  IProduceStorageOrderStore,
  IProduceStorageOrderModel,
} from '@monorepo/types/process/produtionStorage/productionStorage.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IProduceStorageOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
  },
  auditNo: '',
};

const productionProcess: IProduceStorageOrderModel = {
  namespace: 'productionStorageStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default productionProcess;
